export default "__VITE_ASSET__5467575e__"